import { selectCurrentUserSubscriptionPlan } from '@waitroom/auth';
import { isFeatureEnabled, isFreePlan } from '@waitroom/common';
import { useSelector } from 'react-redux';
import { routes } from '../../../constants/routes';

export const useIsIntegrationsEnabled = () => {
  const plan = useSelector(selectCurrentUserSubscriptionPlan);
  const isFree = isFreePlan(plan);
  const isEnabled = isFeatureEnabled(plan, 'integrations');

  const to = !isEnabled ? routes.HOST : routes.DASHBOARD.SUBSCRIPTION.link;

  return {
    isEnabled: !isFree && isEnabled,
    redirectTo: to,
  };
};
